import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Accordion, Divider, Typography } from '@drone-js/core';
import { setSelectedTabOnDetailsPage } from 'component/page/detail/store/details';
import { mapStateToProps, AboutActivityProps } from 'component/page/detail/MoreInfoSections/AboutActivity/AboutActivity.selectors';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesAboutActivityContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import {
    ActivitiesAboutActivityContainerClickEventActivitiesManifestV1,
    ActivitiesAboutActivityContainerSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';
import DetailInViewWrapper from 'component/common/DetailInViewWrapper/DetailInViewWrapper';
import { selectFeatureExperimentsFromBootstrap, selectIsBotOrIsPrerenderFromBootstrap } from 'store/slice/bootstrap';

const AboutActivity: React.FC<AboutActivityProps> = (props) => {
    const { cms, expandedAccordion, content, href, onToggle } = props;
    const isBotOrIsPrerender = useSelector(selectIsBotOrIsPrerenderFromBootstrap);
    const shouldShowAboutActivity = useSelector(selectFeatureExperimentsFromBootstrap).featureBehavior.ShowAboutActivityPanel;
    const aboutActivityState = expandedAccordion[`#${href}` || ''] || isBotOrIsPrerender ? 'expanded' : 'collapsed';

    React.useEffect(() => {
        if (shouldShowAboutActivity && content) {
            trackElementEvent<ActivitiesAboutActivityContainerSeenEventActivitiesFieldsV1>(ActivitiesAboutActivityContainerSeenEventActivitiesManifestV1.ids, {
                is_toggle_on: aboutActivityState === 'expanded',
            });
        }
    }, [aboutActivityState, content, shouldShowAboutActivity]);

    if (!content || !shouldShowAboutActivity) return null;

    return (
        <DetailInViewWrapper tabHref={href || ''} isScrolling={props.isScrolling} setSelectedTabCallback={setSelectedTabOnDetailsPage}>
            <Accordion
                id={href}
                contentSummary={cms[337805]}
                actionType="chevron-icon"
                data-element-name="activities-about-activity-container"
                data-testid="activities-about-activity-container"
                level={2}
                view={aboutActivityState}
                onToggle={onToggle(`#${props.href}` || '', ActivitiesAboutActivityContainerClickEventActivitiesManifestV1.ids)}
            >
                <Typography variant="body-s" tag="p">
                    <AgodaMarkdown input={content} />
                </Typography>
            </Accordion>
            <Divider direction="horizontal" my="4" />
        </DetailInViewWrapper>
    );
};
AboutActivity.displayName = 'AboutActivity';

export default connect(mapStateToProps)(AboutActivity);
